import { render } from "./indexDriveDocumentsComponent.vue?vue&type=template&id=f0b5cfa4"
import script from "./indexDriveDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./indexDriveDocumentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__